export default {"src":"/_next/static/media/food allergies.542f0613.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};